import Ajax from '@utils/ajax';

export function postAcaMigration(data) {
	return Ajax.post('/settings/employment_status/aca_wizard', data);
}
